<script setup>

import {useLanguageStore} from "@/pinia";
import {computed} from "vue";
const languageStore = useLanguageStore();


const props = defineProps(['title'])

const dayKeys = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

const date = computed(() => {
  const today = new Date();
  const year = today.getFullYear();
  const month = ('0' + (today.getMonth() + 1)).slice(-2);
  const day = ('0' + today.getDate()).slice(-2);
  const dayOfWeek = languageStore.get(dayKeys[today.getDay()]);
  return `${year}-${month}-${day} ${dayOfWeek}`;
})


</script>

<template>
  <div class="topTitle">
    <div class="date">
      {{date}}
    </div>
    <div class="title">
      {{title}}
    </div>
  </div>
</template>

<style scoped>
  .topTitle{
    font-size: 1.5rem;
    font-weight: bold;
    display: flex;
    align-items: center;
    width: 73vw;
  }
  .title{
    margin-left: 20vw;
  }
</style>